
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rss/[slug]/[id]",
      function () {
        return require("private-next-pages/rss/[slug]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rss/[slug]/[id]"])
      });
    }
  